import React, { useState } from 'react';

const STRIPE_MONTHLY = 'https://buy.stripe.com/4gMaEW7lb0sOcPDa7q5ZC04';
const STRIPE_ANNUAL  = 'https://buy.stripe.com/3cIaEWgVL1wSg1P3J25ZC03';

function UpgradeButton({ session, isSubscribed, hasFullAccess, trialEndsAt }) {
  const [showPicker, setShowPicker] = useState(false);
  const userId = session?.user?.id;

  // Paid Stripe subscribers see the Manage Subscription button in Settings — nothing here
  if (isSubscribed) return null;

  const daysLeft = trialEndsAt
    ? Math.ceil((new Date(trialEndsAt) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  const monthlyUrl = STRIPE_MONTHLY + (userId ? `?client_reference_id=${userId}` : '');
  const annualUrl  = STRIPE_ANNUAL  + (userId ? `?client_reference_id=${userId}` : '');

  const openCheckout = (url) => {
    sessionStorage.setItem('trp_pending_checkout', 'upgrade');
    window.location.href = url;
  };

  // Active trial with more than 14 days left — status bar; expands to picker on click
  if (hasFullAccess && daysLeft !== null && daysLeft > 14) {
    if (!showPicker) {
      return (
        <div className="trial-status-bar">
          <div className="trial-status-left">
            <span className="trial-status-icon">⏱</span>
            <div>
              <span className="trial-status-badge">Trial Active</span>
              <span className="trial-status-days">
                {daysLeft} day{daysLeft !== 1 ? 's' : ''} remaining
              </span>
            </div>
          </div>
          <button className="trial-status-upgrade" onClick={() => setShowPicker(true)}>
            Upgrade to keep access →
          </button>
        </div>
      );
    }

    // Picker expanded from trial bar
    return (
      <div className="upgrade-cta">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
          <div className="upgrade-cta-heading" style={{ margin: 0 }}>Choose your plan</div>
          <button
            onClick={() => setShowPicker(false)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', fontSize: '0.85rem' }}
          >
            ✕ Cancel
          </button>
        </div>
        <PlanPicker monthlyUrl={monthlyUrl} annualUrl={annualUrl} onChoosePlan={openCheckout} />
      </div>
    );
  }

  // Trial expiring within 14 days or free user — show full picker immediately
  const isExpiringTrial = hasFullAccess && daysLeft !== null && daysLeft <= 14;

  return (
    <div className="upgrade-cta">
      <div className="upgrade-cta-heading">
        {isExpiringTrial
          ? `Your trial ends in ${daysLeft} day${daysLeft !== 1 ? 's' : ''} — lock in your founding rate`
          : 'Get full access to all 2,093+ electrical questions'}
      </div>
      <PlanPicker monthlyUrl={monthlyUrl} annualUrl={annualUrl} onChoosePlan={openCheckout} />
    </div>
  );
}

function PlanPicker({ monthlyUrl, annualUrl, onChoosePlan }) {
  return (
    <>
      <div className="signup-plan-picker">
        <button type="button" onClick={() => onChoosePlan(monthlyUrl)} className="signup-plan" style={{ textDecoration: 'none' }}>
          <div className="signup-plan-name">Monthly</div>
          <div className="signup-plan-price"><span className="price-was">$24.99</span> $9.99<span>/mo</span></div>
        </button>
        <button type="button" onClick={() => onChoosePlan(annualUrl)} className="signup-plan" style={{ textDecoration: 'none' }}>
          <div className="signup-plan-name">Annual <span className="plan-badge">SAVE 34%</span></div>
          <div className="signup-plan-price">$199.00<span>/yr</span></div>
        </button>
      </div>
      <div style={{ fontSize: '0.78rem', textAlign: 'center', opacity: 0.55, marginTop: '0.5rem' }}>
        🔐 Secure checkout via Stripe
      </div>
    </>
  );
}

export default UpgradeButton;
